var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.17 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.54,21.84a2.51,2.51,0,0,0,3.54,0l6.56-6.57,6.57,6.57a2.51,2.51,0,0,0,3.54,0,2.52,2.52,0,0,0,0-3.54l-6.57-6.56,6.57-6.57a2.5,2.5,0,0,0-3.54-3.53L12.64,8.2,6.08,1.64A2.5,2.5,0,0,0,2.54,5.17l6.57,6.57L2.54,18.3A2.52,2.52,0,0,0,2.54,21.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.51,30.25H37.64a5.53,5.53,0,0,0-5.58,5.58V48.7a5.53,5.53,0,0,0,5.58,5.58H50.51A5.67,5.67,0,0,0,56.07,49a2.29,2.29,0,0,0,0-.25V35.83A5.52,5.52,0,0,0,50.51,30.25ZM37.06,35.83a.57.57,0,0,1,.58-.58H50.51a.57.57,0,0,1,.58.58V48.51c0,.18-.14.77-.58.77H37.64a.57.57,0,0,1-.58-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.64,29.71A12.65,12.65,0,1,0,25.29,42.36,12.66,12.66,0,0,0,12.64,29.71Zm0,20.29a7.65,7.65,0,1,1,7.65-7.64A7.65,7.65,0,0,1,12.64,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.84,19.73,46.15,1.25a2.5,2.5,0,0,0-4.33,0L31.13,19.73a2.5,2.5,0,0,0,2.17,3.75H54.67a2.5,2.5,0,0,0,2.17-3.75Zm-6.5-1.25H37.63L44,7.49Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/Games.7ccfe1cf.svg";
export { ForwardRef as ReactComponent };